export const trimText = (
  text: string,
  length: number,
  textOverflow?: string
) => {
  if (text?.length > length) {
    return text.slice(0, length) + (textOverflow || '...')
  }
  return text
}

export const toCamelCase = (text: string) => {
  // converting all characters to lowercase
  const ans = text.toLowerCase()

  // Returning string to camelcase
  return ans
    .split(' ')
    .reduce((s, c) => s + (c.charAt(0).toUpperCase() + c.slice(1)))
}

// Sanitize text to remove any html tags
export const sanitizeText = (text: string) => {
  const temp = document.createElement('div')
  temp.innerHTML = text
  return temp.textContent || temp.innerText || ''
}

// First letter of each word to uppercase
export const toTitleCase = (text: string) => {
  return text.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  )
}
